import * as go from 'gojs';
import noop from 'lodash/noop';
import { registerLinkTemplate } from '../../common/utils/registerNodeTemplate';
import { linkTemplate } from './../link';
import { linkOverrideDraggingTool } from './../utils/link-dragging.tool';
import { linkOverrideLinkingTool } from './../utils/link-linking-tool';
import { linkOverrideRelinkingTool } from './../utils/link-relinking.tool';

export const setupLink = (diagram: go.Diagram, categoryName: string) => {
  registerLinkTemplate(diagram, categoryName, linkTemplate());
  linkOverrideLinkingTool(diagram, categoryName);
  linkOverrideRelinkingTool(diagram, categoryName);
  linkOverrideDraggingTool(diagram);

  return noop;
};
